let errorsList = {
  GENERAL_ERROR: "Hubo un error.",
  RECORDS_MISMATCH: "Hay una falta de coincidencia en el número de registros.",
  RECORDS_NOT_EXISTS: "Algunos registros no existen.",
  RECORD_NOT_EXIST: "El registro no existe.",
  NO_RECORDS: "No se encontraron resultados.",
  CORRUPTED_DATA: "La información enviada está dañada.",
  UNAUTHORIZED_ACCESS: "El usuario no cuenta con el rol requerido",
  INVALID_DATA: "La solicitud tiene información no válida.",
  INVALID_PASSWORD:
    "Asegúrese de que su contraseña contenga letras mayúsculas / minúsculas, un número, un carácter especial y tenga entre 8 y 32 caracteres.",
  DUPLICATE_RECORD: "La información no es única.",
  REQUIRED_FIELDS: "Faltan algunos campos obligatorios.",
  EXPIRED_CONTENT: "El recurso solicitado ha caducado.",
  UPDATE_NOTHING: "No hay nada que actualizar.",
  CONFIG_KEY_NOT_DEFINED: "Aún no se ha definido una clave de configuración.",
  FEATURE_NOT_IMPLEMENTED_YET: "Esta función aún no está implementada.",
  END_DATE_LOWER_THAN_START_DATE:
    "La fecha de finalización no debe ser inferior a la fecha de inicio.",
  USER_WRONG_CREDENTIALS:
    "El correo electrónico o la contraseña son incorrectos.",
  USER_NOT_EXISTS: "El usuario no sale.",
  USER_ALREADY_EXISTS: "El usuario ya existe.",
  USER_ACCOUNT_SUSPENDED: "Esta cuenta ha sido suspendida.",
  USER_UPDATE_NO_IDS:
    "Todos los modelos de usuario deben tener una identificación.",
  USER_UPDATE_EMAIL_NOT_UNIQUE: "El correo electrónico ya está en uso.",
  USER_REGISTER_MISSING_REQUIRED_FIELDS: "Faltan algunos campos obligatorios.",
  USER_DELETE_HAS_SCHEDULED_TRIPS:
    "No se pudo borrar porque el usuario ha programado viajes.",
  FACEBOOK_LOGIN_GRAPH_API_USER_INFO_ERROR:
    "Hubo un error al solicitar información de usuario de Facebook Graph API.",
  TWILIO_SMS_SEND_VERIFICATION_CODE_ERROR: "Hubo un error al enviar el sms.",
  SMS_VERIFY_NOT_VALIDATED_CODE: "El código no ha sido validado.",
  SMS_VERIFY_INVALID_CODE: "El código proporcionado no es válido.",
  SMS_VERIFY_ALREADY_VERIFIED: "El número de teléfono ya está verificado.",
  SMS_VERIFY_TOO_MANY_ATTEMPTS:
    "Demasiados intentos, inténtalo de nuevo más tarde.",
  CELL_NOT_EXISTS: "La celda no existe.",
  CLIENT_NOT_EXISTS: "El cliente no existe.",
  VALIDATION_ERROR: "Algunos campos no son válidos.",
  UNAUTHORIZED_ACTION: "No estás autorizado a realizar esta acción.",
  FORBIDDEN_ACTION: "Esta acción no está permitida.",
  TRIP_NOT_EXISTS: "El viaje no existe.",
  TRIP_NOT_EMPLOYEES_PROGRAM:
    "El viaje no pertenece a un cliente en el programa de empleados.",
  USER_NOT_EMPLOYEES_PROGRAM_ROUTE_ACCESS:
    "El usuario no tiene acceso a la ruta del viaje.",
  TRIP_UNAVAILABLE: "El viaje no está disponible actualmente.",
  TRIP_CANNOT_BE_CANCELLED: "El viaje no se puede cancelar.",
  THE_TRUCK_HAS_ALREADY_PASSED: "El camión ya pasó por la parada.",
  ACTIVE_TRIP_ALREADY_EXISTS: "Ya tienes un viaje activo.",
  CANCELLATION_VAN_EMPTY_AGENT_COMMENT:
    "el comentario del agente no debe estar vacío.",
  INCAN_VAN_EMPTY_AGENT_COMMENT:
    "el comentario del agente no debe estar vacío.",
  INCAN_VAN_EMPTY_ACTION: "La acción no debe estar vacía.",
  INCIDENTS_VAN_CANNOT_CANCEL_WEB_ACCOUNT:
    "No se puede cancelar una cuenta web.",
  CLIENT_CODE_NOT_EXISTS: "El código de cliente no existe.",
  CLIENT_CODE_DISABLED: "El código de cliente está deshabilitado.",
  CLIENT_CODE_NOT_MATCH:
    "El código proporcionado no coincide con el código del cliente.",
  CLIENT_CODE_SPECTATOR_CANT_ASSIGN:
    "No es posible asignar un código de cliente.",
  USER_CANT_ASSIGN_EMPLOYEE_REFERENCE:
    "No es posible asignar una referencia de empleado.",
  EXCEL_NO_PARSED_RECORDS: "No fue posible analizar registros.",
  EXCEL_PROCESSING_LINE_ERROR:
    "Hubo un problema al procesar la línea $ {line}, verifique su archivo.",
  RATE_TAB_VAN_NOT_EXISTS: "La pestaña de la tarifa no existirá.",
  RATE_TAB_DETAIL_VAN_NOT_EXISTS:
    "La pestaña de detalles de la tarifa no existirá.",
  CONEKTA_PAYMENT_METHOD_UNKNOWN: "El método de pago es desconocido.",
  CONEKTA_PAYMENT_METHOD_CREATE_ERROR:
    "Hubo un error al crear la fuente de pago.",
  CONEKTA_CUSTOMER_CREATE_ERROR: "Hubo un error al crear el cliente.",
  CONEKTA_PAYMENT_METHOD_DELETE_ERROR:
    "Hubo un error al eliminar la forma de pago.",
  CONEKTA_PAYMENT_METHOD_UPDATE_ERROR:
    "Hubo un error al actualizar la forma de pago.",
  CONEKTA_ORDER_CREATE_ERROR: "No se pudo crear el pedido.",
  CONEKTA_ORDER_REFUND_ERROR: "No se pudo reembolsar el pedido.",
  CONEKTA_ORDER_KONECT_VAN_TEMP_CREATE_ERROR:
    "Hubo un error al crear la orden de cargo de validación.",
  CONEKTA_ORDER_KONECT_VAN_TEMP_REFUND_ERROR:
    "Hubo un error al reembolsar la orden de cargo de validación.",
  MAX_LENGTH_100: "La longitud máxima de la cadena de texto es 100.",
  MAX_LENGTH_1000: "La longitud máxima de la cadena de texto es 1000.",
  LOWER_LIMIT_MUST_BE_LOWER: "El límite inferior debe ser inferior.",
  REPEATED_KM: "Los rangos de kilómetros no se pueden repetir.",
  CANNOT_START_TRIP_IN_THIS_STATUS:
    "Un viaje solo se puede iniciar en un estado nuevo, programado y reprogramado.",
  CANNOT_FINISH_TRIP_IN_THIS_STATUS:
    "No se puede completar un viaje en este estado.",
  COST_TRIP_HAS_CHANGED: "El costo del viaje ha cambiado. Vuelve a intentarlo.",
  CANNOT_CALCULATE_COST_TRIP_ERROR:
    "El tabulador de costos está mal diseñado y no permite darle un costo al viaje.",
  CANNOT_CALCULATE_DISTANCE_KM:
    "No se puede calcular la distancia entre puntos a través de Google.",
  NO_SEATS_AVAILABLE:
    "No hay asientos disponibles para la cantidad solicitada.",
  PROMOTION_NOT_VALID_FOR_KM_RANGE:
    "La promoción no aplica a este viaje porque no está en el rango permitido de km.",
  PROMOTION_NOT_VALID_BY_NUMBER_OF_USERS:
    "Promoción no válida porque supera el número de usuarios permitidos.",
  PROMOTION_NOT_VALID_FOR_EXCEEDING_REPETITIONS:
    "La cantidad de veces que el usuario puede usar este cupón ha alcanzado su límite.",
  PROMOTION_NOT_VALID_FOR_THIS_ROUTE:
    "Esta promoción no se aplica a esta ruta.",
  PROMOTION_NOT_VALID_FOR_THIS_USER:
    "Esta promoción no se aplica a este usuario.",
  PROMOTION_NOT_VALID: "Esta promoción no es válida.",
  PROMOTION_NOT_VALID_BY_DATE_RANGE:
    "Promoción no válida porque no está dentro del período.",
  PROMOTION_NOT_VALID_FOR_LACK_USE:
    "La promoción no es válida porque excede los usos mínimos mensuales.",
  PROMOTION_NOT_VALID_FOR_FREQUENT_USE:
    "La promoción no es válida porque no supera los usos mínimos mensuales.",
  PROMOTION_NOT_VALID_EXCEEDS_THE_NUMBER_ALLOWED_PER_TRIP:
    "La promoción no válida supera el número permitido por viaje.",
  TRIP_LIQUIDATION_NOT_VALID_AMOUNT: "La cantidad proporcionada no es válida.",
  SESSION_NOT_VALID: "La sesión es incorrecta.",
  USER_WITHOUT_PHONE: "El usuario no tiene un número de teléfono registrado.",
  FILE_UPLOAD_WRONG_QUANTITY: "No es posible cargar este número de archivos.",
  FILE_UPLOAD_NOT_SUPPORTED_FILE_TYPE: "El tipo de archivo no es compatible.",
  FILE_UPLOAD_SKIPPER_E_EXCEEDS_UPLOAD_LIMIT: "",
  FILE_UPLOAD_WRONG: "El archivo excede el tamaño permitido.",
  DURATION_INVALID: "La duracion debe ser mayor.",
  PRICE_INVALID: "El precio debe ser mayor.",
  INCORRECT_DATE: 'Fecha incorrecta',
  JSON_FILE_SAVE_ERROR: 'Hubo un error al guardar el archivo json',
  JSON_FILE_READ_ERROR: 'Hubo un error al guardar el archivo json',
  MAIL_SEND_ERROR: 'Hubo un error al enviar el correo electrónico',
  USER_CANNOT_BE_UPDATED: 'El usuario no puede ser actualizado.',
  TRIP_CANNOT_BE_CANCELLED_PENALTY_NOT_FOUND: 'The trip can not be cancelled because penalty not found',
  CLIENT_CODE_USER_CANNOT_BE_DISABLE: 'No se puede deshabilitar el código de un usuario que no pertenece a la empresa',
  PROMOTION_NOT_VALID_EXCEEDS_ALLOWED_NUMBER_REGISTRATIONS: 'La promoción no es válida por exceder el número de registros permitidos',
  PROMOTION_NOT_VALID_FOR_THIS_SERVICE_TYPE: 'La promoción no es válida para este tipo de servicio',
  FILE_UPLOAD_MUST_NOT_BE_EMPTY: 'El campo no debe estar vacío.',
  PAYMENT_METHOD_NOT_ALLOWED: 'Método de pago no permitido',
  EXCEEDS_THE_NUMBER_OF_PASSENGERS_ALLOWED: 'Excede el número de pasajeros permitido',
  SIGUE_CONNECTION_ERROR: 'Hubo un error al conectarse a la API',
  SIGUE_ENDPOINT_ERROR: 'Hubo un error al llamar a la API',
  TRIP_STATUS_NOT_EXISTS: 'El estado del viaje solicitado no existe',
  TRIP_USER_EXPERIENCE_PENDING_PAYMENTS: 'Todavía hay pagos pendientes',
  TRIP_USER_EXPERIENCE_TRANSFER_NOT_VALID_TIME_INTERVAL: 'La fecha actual es mayor que el intervalo de transferencia',
  TRIP_USER_EXPERIENCE_TRANSFER_NOT_VALID_TRIP_STATUS: 'El estado actual del viaje no es válido para la transferencia',
  TRIP_USER_EXPERIENCE_TRANSFER_NOT_VALID_USER: 'El usuario proporcionado no es válido',
  TRIP_USER_EXPERIENCE_CANNOT_UPDATE: 'Este viaje no se puede actualizar',
  TRIP_USER_EXPERIENCE_CONEKTA_RESERVATION_ORDER_CREATE_ERROR: 'No se pudo crear la orden de reserva de conekta para una experiencia',
  THERE_ARE_ACTIVE_TRIPS_CANNOT_BE_MODIFIED: 'No se puede modificar porque hay viajes reservados y/o preautorizados',
};

export default errorsList;
